import { render, staticRenderFns } from "./BannerDetailView.vue?vue&type=template&id=73a4fd5c&scoped=true"
import script from "./BannerDetailView.vue?vue&type=script&lang=js"
export * from "./BannerDetailView.vue?vue&type=script&lang=js"
import style0 from "./BannerDetailView.vue?vue&type=style&index=0&id=73a4fd5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a4fd5c",
  null
  
)

export default component.exports